










































import Vue, { PropType } from 'vue';
import CardLayout from '@/components/card-layout/CardLayout.vue';
import SummaryListItem from './SummaryListItem.vue';
import { Appointment, ApptSummary, JobAppointment } from '@/types';
import InfoIcon from '@/assets/icons/InfoIcon.vue';
import { isApptEditable } from '@/util';
import { ApptStatusMessage, EventType, JobStatus, Routes } from '@/constants';
import { mapGetters } from 'vuex';
import { bus } from '@/main';
import { getAppointmentStatus } from '@/views/appointments/services/service';
import { jobOwnershipStatus } from '../../services/service';

export default Vue.extend({
  name: 'AppointmentSummary',
  components: {
    CardLayout,
    InfoIcon,
    SummaryListItem
  },
  data () {
    return {
      selectedContactModal: '',
      isVisibleViewVersion: false,
      Routes
    };
  },
  props: {
    appointment: {
      type: Object as PropType<JobAppointment>,
      required: true
    },
    pendingAppointments: {
      type: Array as PropType<Appointment[]>,
      required: true
    },
    unavailableAppointments: {
      type: Array as PropType<Appointment[]>,
      required: true
    }
  },
  computed: {
    ...mapGetters(['isLoggedInAsAdmin']),
    postClose (): boolean {
      return [JobStatus.POST_CLOSE].includes(jobOwnershipStatus());
    },
    filterAppointments (): ApptSummary[] {
      const filteredAppointments = [] as ApptSummary[];
      if (this.postClose) {
        this.appointment.appointments.forEach((appointment) => {
          if (appointment.stage.phase.phase.toLowerCase() === 'own') {
            filteredAppointments.push(appointment);
          }
        });
        return filteredAppointments;
      }
      return this.appointment.appointments;
    },
    filteredPendingAppointments (): Appointment[] {
      const filteredAppointments = [] as Appointment[];
      if (this.postClose) {
        this.pendingAppointments.forEach((appointment) => {
          if (appointment.stage.phase.phase.toLowerCase() === 'own') {
            filteredAppointments.push(appointment);
          }
        });
        return filteredAppointments;
      }
      return this.pendingAppointments;
    },
    filteredUnavailableAppointments (): Appointment[] {
      const filteredAppointments = [] as Appointment[];
      if (this.postClose) {
        this.unavailableAppointments.forEach((appointment) => {
          if (appointment.stage.phase.phase.toLowerCase() === 'own') {
            filteredAppointments.push(appointment);
          }
        });
        return filteredAppointments;
      }
      return this.unavailableAppointments;
    },
    appointmentsExist (): boolean {
      return !!(this.appointment?.appointments?.length || this.pendingAppointments.length);
    }
  },
  methods: {
    isAppointmentEditable (appointment: ApptSummary) {
      return isApptEditable(appointment.startDate, appointment.isFromFeedAppointment, appointment.customerCanScheduleAppointment);
    },
    showAppointmentDetails (appointmentId: string) {
      this.$emit(EventType.SHOW_DETAILS, appointmentId);
    },
    setOpenedModal (appointmentId: string) {
      this.selectedContactModal = appointmentId;
    },
    scheduleAppointment (appointment: Appointment) {
      if (!this.isLoggedInAsAdmin) {
        this.$router.push({
          name: Routes.SCHEDULE_APPOINTMENT,
          params: {
            appointmentTypeId: appointment.appointmentType.appointmentTypeId
          },
          query: {
            appointmentId: appointment.appointmentId,
            prev: Routes.DASHBOARD
          }
        });
      } else {
        bus.$emit(EventType.VIEW_VERSION);
      }
    },
    appointmentStatus (appointment: Appointment): string {
      if (this.postClose && appointment.stage.phase.phase.toLowerCase() !== 'own') {
        return ApptStatusMessage.Completed;
      }
      return getAppointmentStatus(appointment);
    }
  }
})
